import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { useHistory } from 'react-router-dom';

export function useInitialiseTabs() {
  const history = useHistory();
  const bookingListingActiveTab = useSelector((state: IRootState) => state.bookingsStore.bookingListingActiveTab);
  const dispatch = useDispatch<IRootDispatch>();
  const defaultBookingViews = useSelector((state: IRootState) => state.bookingsStore.defaultBookingViews);
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );

  // useEffect(() => {
  //   const showActiveTab = _.get(history, 'location.state.showActiveTab');
  //   if (bookingListingActiveTab) {
  //     if (showActiveTab || !bookingListingActiveTab.isDefault) {
  //       dispatch.bookingsStore.setDisplayedBookingListingTabs([
  //         ...displayedBookingListingTabs,
  //         bookingListingActiveTab,
  //       ]);
  //     } else {
  //       dispatch.bookingsStore.setBookingListingActiveTab(bookingListingActiveTab);
  //     }
  //   } else {
  //     dispatch.bookingsStore.setBookingListingActiveTab(defaultBookingViews[0]);
  //   }

  //   let activeTab = defaultBookingViews[0];
  //   if (!_.isEmpty(bookingListingActiveTab) && _.get(bookingListingActiveTab, 'filterValue')) {
  //     activeTab = bookingListingActiveTab;
  //   }
  //   const appliedFilters = activeTab?.filterValue;
  //   if (appliedFilters) {
  //     dispatch.bookingsStore.setBookingsFilter(appliedFilters);
  //   }
  // }, [bookingListingActiveTab, defaultBookingViews, displayedBookingListingTabs, dispatch.bookingsStore, history]);
}
